
export const initialState = {
    isLoading: false,
    errorMsg: '',
    successMsg: '',
    practice: null,
    selectedUser: null,
    selectedService: null,
    selectedServiceTypes: [],
    setupMessage: null,
};

export const PracticeUserReducer = (state = initialState, action) => {
    
    switch(action.type){
        case 'setPracticeField': {
            return {
                ...state,
                [action.fieldName]: action.payload,
            };
        }

        case 'selectService': {
            return {
                ...state,
                selectedService: action.payload,
                successMsg: '',
                errorMsg: '',
            };
        }

        case 'selectUser': {
            return {
                ...state,
                selectedUser: action.payload,
                successMsg: '',
                errorMsg: '',
            };
        }

        case 'serviceTypeChange': {
            return {
                ...state,
                selectedServiceTypes: action.payload,
            };
        }
        case 'practiceLoginSuccess': {
            return {
                ...state,
                practice: action.payload,
                successMsg: '',
                errorMsg: ''
            };
        }
        case 'updatePracticeDetails': {
            return {
                ...state,
                practice: action.payload,
            }
        }
        case 'practiceUpdateSuccess': {
            return {
                ...state,
                successMsg: 'Practice Updated Successfully',
                errorMsg: ''
            };
        }
        case 'addServiceSuccess': {
            return {
                ...state,
                // practice: action.payload,
                successMsg: 'Service Location added successfully',
                errorMsg: '',
                selectedServiceTypes: [],
            };
        }
        case 'practiceUpdateError': {
            return {
                ...state,
                errorMsg: action.payload,
                successMsg: ''
            };
        }
        case 'deleteServiceSuccess': {
            return {
                ...state, 
                successMsg: 'Service Location deleted successfully for Practice !',
                errorMsg: '',
                practice: action.payload,
            };
        }
        case 'addUserSuccess': {
            return {
                ...state,
                successMsg: 'User Registered Successfully',
                errorMsg: ''
            };
        }
        case 'editUserSuccess': {
            return {
                ...state,
                successMsg: 'User Updated Successfully',
                errorMsg: ''
            };
        }
        case 'editPasswordSuccess': {
            return {
                ...state,
                successMsg: 'Password Updated Successfully',
                errorMsg: ''
            };
        }
        case 'deleteUserSuccess': {
            return {
                ...state,
                successMsg: 'User Deleted Successfully',
                errorMsg: ''
            };
        }
        case 'clearMsg': {
            return {
                ...state,
                successMsg: '',
                errorMsg: ''
            }
        }
        case 'clearServiceType': {
            return {
                ...state,
                selectedServiceTypes: []
            }
        }
        case 'settingsUpdateSuccess': {
            return {
                ...state,
                practice: action.payload,
                successMsg: 'Basic Details Updated Successfully',
                errorMsg: ''
            } 
        }
        case 'basicSettingsUpdateSuccess': {
            return {
                ...state,
                successMsg: 'Basic Details Updated Successfully',
                errorMsg: ''
            }
        }
        case 'updateSelectedUser': {
            return {
                ...state,
                selectedUser: action.payload,
            };
        }
        case 'logoutPractice': {
            return {
                ...state,
                isLoading: false,
                errorMsg: '',
                successMsg: '',
                practice: null,
                selectedUser: null,
                selectedService: null,
                selectedServiceTypes: [],
            };
        }
        case 'clearMessage': {
            return {
                ...state,
                errorMsg: '',
                successMsg: '',
                setupMessage: null,
            }
        }
        case 'showSetupMessage': {
            console.log('practiceUserReducer: showSetupMessage action received:', action.payload);
            return {
                ...state,
                setupMessage: action.payload,
            }
        }
        default: 
            return state

    }
    
    
};